import { normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/map/216022/pickey.png';
const _withScopeId = n => (_pushScopeId("data-v-76a0ee54"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "map",
  class: "map_content",
  ref: "maps"
};
const _hoisted_2 = {
  class: "tabul"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["src"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pickey"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_maplist = _resolveComponent("maplist");
  const _component_mappopup = _resolveComponent("mappopup");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", {
    class: _normalizeClass(["loading", {
      'hide': !$data.loading
    }]),
    "element-loading-text": "加载中"
  }, null, 2), [[_directive_loading, $data.loading]]), _createElementVNode("div", _hoisted_1, null, 512), _createElementVNode("div", {
    class: _normalizeClass(["mapcontainer", [{
      'hasPop': $data.popshowflag
    }]]),
    id: "mapcontainer"
  }, null, 2), _createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.areaList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: index,
      class: _normalizeClass({
        'hide': $data.cid === index
      }),
      onClick: $event => $options.switchArea(index)
    }, [_createElementVNode("img", {
      src: item.image,
      alt: ""
    }, null, 8, _hoisted_4)], 10, _hoisted_3);
  }), 128))]), _hoisted_5, $data.dataList !== '' ? (_openBlock(), _createBlock(_component_maplist, {
    key: 0,
    isApp: $data.isApp,
    dataList: $data.dataList,
    iconSource: $data.iconSource,
    mapdataform: $data.mapdataform,
    typeList: $data.typeList,
    onListmarkerclick: $options.listmarkerclick,
    onPrompt: $options.showprompt
  }, null, 8, ["isApp", "dataList", "iconSource", "mapdataform", "typeList", "onListmarkerclick", "onPrompt"])) : _createCommentVNode("", true), _createVNode(_component_mappopup, {
    detail: $data.detail,
    popshowflag: $data.popshowflag,
    modeltype: $data.modeltype,
    onCloseHandle: $options.closeHandle
  }, null, 8, ["detail", "popshowflag", "modeltype", "onCloseHandle"]), _withDirectives(_createElementVNode("div", {
    class: "shade",
    onClick: _cache[0] || (_cache[0] = $event => $data.popshowflag = false)
  }, null, 512), [[_vShow, $data.popshowflag]]), _createElementVNode("div", {
    class: "goback icon-back",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goHome && $options.goHome(...args))
  })]);
}